<template>
    <main-content-wrapper>
        <h1 class="text-md-center">
            SPREMEMBA GESLA
            <span>V spodnja polja vpišite poljubno geslo.</span>
        </h1>
        <v-layout justify-center row wrap fill-height >
            <v-flex xs12 md6 pl-5 pr-5 pt-4 pb-4 class="border">
                <v-form v-model="valid" @submit.prevent="">
                    <password-field v-model="password" :rules="newPasswordRules" label="Geslo" v-on:keypress.enter="resetPassword" required />
                    <password-field v-model="password_again" :rules="[checkNewPasswordAgain]" label="Ponovno vpišite geslo" v-on:keypress.enter="resetPassword" required />
                </v-form>
                <v-btn depressed large block color="primary_action" @click="resetPassword" :loading="loading">NASTAVI GESLO</v-btn>
            </v-flex>
        </v-layout>
    </main-content-wrapper>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";
    import InputField from "../components/InputField";
    import EmptySpace from "../components/EmptySpace";
    import utils from "../store/utils";
    import PasswordField from "../components/PasswordField";
    import validations from "../components/validations";

    export default {
        name: "ForgotPasswordNew",
        data: vm => ({
            valid: false,
            password: null,
            password_again: null,
            newPasswordRules: validations.newPasswordRules,
        }),
        components: {MainContentWrapper, InputField, EmptySpace, PasswordField},
        computed:{
            loading: utils.vuexBuildSetGet(this, 'auth', 'loading'),
        },
        methods: {
            resetPassword() {
                if (this.valid) {
                    this.$store.dispatch('auth/resetPassword', {password: this.password});
                }
            },
            checkNewPasswordAgain(v) {
                return validations.newPasswordCheckAgain(v, this.password);
            }
        }
    };

</script>

<style scoped>

</style>